import { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useDispatch } from 'react-redux'
import { forgotPassword } from 'actions/auth'
import Panel, { PanelHeading, PanelSubheading } from 'components/layout/Panel'
import Page from 'rui/widgets/Page'
import Thin from 'components/layout/Thin'
import Form, { baseError } from 'components/form'
import Input from 'components/form/Input'
import { required } from 'components/form/validations'
import ResetPasswordForm from 'components/form/ResetPassword'
import Spacer from 'components/misc/Spacer'
import { LinkButton } from 'components/layout/buttons'
import { is4xxError, is5xxError } from 'util/server/utils'
import { LocalizedText, useLocalization } from 'localization'

const ForgotPassword = ({ app }) => {
  const { t } = useLocalization()
  const dispatch = useDispatch()
  const [sentTo, setSentTo] = useState(null)

  const handleData = (data) => {
    return dispatch(forgotPassword(data.email, app)).then(
      () => {
        setSentTo(data.email)
      },
      (error) => {
        const status = error?.response?.rawResponse?.status

        const message = is4xxError(status)
          ? t('dweb_forgot_password_email_address_not_found')
          : is5xxError(status)
            ? t('dweb_forgot_password_server_error_try_again_later')
            : t('dweb_forgot_password_connection_error_try_again')

        return baseError(message, 'email')
      }
    )
  }

  const resetForm = (emailParam) => {
    return <ResetPasswordForm temporarySentTo={emailParam || sentTo} />
  }

  const sendForm = () => {
    return (
      <Form id="forgot-password-form" onData={handleData}>
        <Panel>
          <PanelHeading>
            <LocalizedText translationKey="dweb_forgot_password" />
          </PanelHeading>
          <PanelSubheading>
            <LocalizedText translationKey="dweb_forgot_password_enter_email_address_associated_roadie_account" />
          </PanelSubheading>

          <Input.Email label={t('dweb_forgot_password_email_address')} name="email" validate={required} />

          <Input.Submit value={t('dweb_common_next')} />
          <Spacer height="1.6rem" />
          <LinkButton id="sign-in" to="sign-in">
            <LocalizedText translationKey="dweb_forgot_password_back_sign" />
          </LinkButton>
        </Panel>
      </Form>
    )
  }

  const getCurrentForm = () => {
    const url = new URL(window.location)

    if (url.searchParams.has('email')) {
      return resetForm(url.searchParams.get('email'))
    }

    return sentTo ? resetForm() : sendForm()
  }

  return (
    <Page>
      <Helmet>
        <title>{t('dweb_forgot_password')}</title>
      </Helmet>
      <Thin>{getCurrentForm()}</Thin>
    </Page>
  )
}

export default ForgotPassword
